import React from 'react'
import {Box, Stack} from '@mui/material';
import DayIcon from '../icon';
import styles from './days-info.module.scss';
import {useIntl} from 'react-intl';
import { useMediaQuery } from 'react-responsive';
import { Lx } from '../../../../../../../i18n/consts';

interface DayInfoProps {
    day: number,
    info: string,
    color?: string,
    className?: string,
}

const DayInfo = (props: DayInfoProps) => {
    const {day, info, color, className} = props;

    return <Stack direction='row' alignItems='center' className={styles.dayInfo}>
        <Box className={className ? `${styles.dayIconWrapper} ${className}` : styles.dayIconWrapper}>
            <DayIcon color={color} day={day} disabled={true}/>
        </Box>
        <span>-</span>
        <span>{info}</span>
    </Stack>
}

const DaysInfo = () => {
    const intl = useIntl()
    const isDesktop = useMediaQuery({ minWidth: 1001 });
    const workDayColor = isDesktop ? 'var(--card-sectionning-background-color)' : undefined;

    return <Box className={styles.infoRow}>
        <span className={styles.dayInfoLabel}>{intl.formatMessage({ id: Lx.Calendar.CHOOSE_DAY_TO_EDIT })}</span>
        <Box className={styles.dayIcons}>
            <DayInfo 
                day={1} 
                info={intl.formatMessage({id: Lx.Calendar.WORK_DAY})} 
                color={workDayColor} className={styles.border}/>
            <DayInfo
                day={2}
                info={intl.formatMessage({id: Lx.Calendar.WEEKEND_OR_DAY_OFF})}
                color='var(--background-accent-subdued)'/>
            <DayInfo
                day={4}
                info={intl.formatMessage({id: Lx.Calendar.CUSTOM_DAY})}
                color='var(--background-success-subdued)'/>
        </Box>
    </Box>
}

export default React.memo(DaysInfo);
